import React from 'react'
import { Row, Col, Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import SidePopup from 'components/SidePopup'

const AccountActivated = ({ history }) => (
  <SidePopup onHide={() => history.push('/')}>
    <Row className='reset-password'>
      <Col xs='12'>
        <div className='section-title'>{I18n.t('signup_account_activated_title')}</div>
        <div className='section-subtitle'>{I18n.t('signup_account_activated_subtitle')}</div>
      </Col>

      <Col xs='12' className='mt-3'>
        <Button color='primary' className='w-100' onClick={() => history.push('/login')}>
          {I18n.t('button_login')}
        </Button>
      </Col>
    </Row>
  </SidePopup>
)

export default AccountActivated
